import { IImageStyles } from '@fluentui/react';
import { tenantBrandingBreakpoint, msGridUnit } from '../constants';

export const tenantBrandingStyles: IImageStyles = {
  root: {
    margin: `0 ${msGridUnit * 2}px 0 ${msGridUnit}px`,
    display: 'flex',
    alignItems: 'center'
  },
  image: {
    selectors: {
      [`@media (max-width: ${tenantBrandingBreakpoint}px)`]: {
        height: `${msGridUnit * 2.5}px`
      }
    }
  }
};
